const createBody = (body, type = 'atlas_doc_format') => {
	const json = {};
	json[type] = {
		value: JSON.stringify(body),
		representation: type,
	};
	return json;
};

export const confluenceParentPost = (contentType, spaceKey, title, body) => ({
	type: contentType,
	space: {
		key: spaceKey,
	},
	title,
	body: createBody(body),
});

export const confluenceParentPut = (contentType, spaceKey, title, body, versionNumber) => ({
	type: contentType,
	space: {
		key: spaceKey,
	},
	title,
	body: createBody(body),
	version: {
		number: versionNumber,
	},
});

export const confluenceChildPost = (
	contentType,
	parentType,
	spaceKey,
	parentId,
	title,
	body,
	type,
) => ({
	type: contentType,
	space: {
		key: spaceKey,
	},
	container: {
		type: parentType,
		id: parentId,
	},
	title,
	body: createBody(body, type),
	metadata: {
		properties: {
			atl_cq_votes: {
				key: 'atl_cq_votes',
				value: {
					total: 0,
				},
			},
		},
	},
});

export const confluenceChildPut = (
	contentType,
	parentType,
	spaceKey,
	parentId,
	title,
	body,
	versionNumber,
	type,
) => ({
	version: {
		number: versionNumber,
	},
	space: {
		key: spaceKey,
	},
	container: {
		type: parentType,
		id: parentId,
	},
	type: contentType,
	title,
	body: createBody(body, type),
});
